// Libraries
import styled from 'styled-components'

// Components
import { Aligner, Body, FormButton, Icon } from 'heeds-ds'

type Props = {
  visible?: boolean
}

export const Container = styled.div<Props>`
  background: ${({ theme }) => theme.colors.surface.default};
  border-left: 4px solid ${({ theme }) => theme.colors.icon.default};
  border-radius: 4px 0 0 4px;
  padding: ${({ visible }) => (visible ? '0 0 16px' : '0')};
`

export const ExpandIcon = styled(Icon).attrs((props) => ({
  color: props.theme.colors.icon.default,
}))``

export const GradientWhite = styled.div`
  background: linear-gradient(#fff0, #fff5 10%, #fff 70%, #fff);
  bottom: 0;
  height: 142px;
  left: 0;
  position: fixed;
  width: 100vw;
  z-index: 1;
`

export const Header = styled(Aligner).attrs(() => ({
  justify: 'space-between',
  padding: '16px 16px 24px 32px',
}))``

export const SaveButton = styled(FormButton).attrs(() => ({
  margin: '18px auto auto',
  size: 'small',
}))``

export const Title = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.secondary,
  fontSize: '14px',
  type: 'copy4',
  weight: 600,
}))``

export const WorkoutSets = styled(Aligner).attrs(() => ({
  flex: 'column',
  gap: '8px',
}))``
